export default "__VITE_ASSET__Z$x3SstJoGbuPb7g6pBevQ__"